import { ActiveOrder } from '@/resources/types'
import { createContext, useContext } from 'react'

export type OrdersWebSocketContextType = {
  orders: ActiveOrder[]
  isWebSocketConnected: boolean
  isLoading: boolean
  isWebSocketActive: boolean
  hasUpdatedOrders: boolean
  patchOrderStatus: (orderNumber: string, status: string) => void
}

export const OrdersWebSocketContext = createContext<OrdersWebSocketContextType>(
  {
    orders: [],
    isWebSocketConnected: false,
    isLoading: false,
    isWebSocketActive: false,
    hasUpdatedOrders: false,
    patchOrderStatus: () => undefined,
  }
)

const useOrdersWebSocket = () => {
  const context = useContext(OrdersWebSocketContext)
  if (!context) {
    throw new Error(
      'useOrdersWebSocket must be used within OrdersWebSocketContext'
    )
  }
  return context
}

export default useOrdersWebSocket
